/* istanbul ignore file */
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

import { useHttpClient } from '@bonusly/http-client';

import { CompanyItemCategoriesResponse, CompanyItemCategory, ItemType } from './types';

// Returns an alphabetically sorted list of company item categories,
// with a catch-all category at the end and exclusives and swag at the beginning
export const useRetrieveCompanyItemCategories = (enabled: boolean) => {
	const http = useHttpClient('rcs');
	const { t } = useTranslation('rewards');

	return useQuery(['company-item-categories'], () => http.get<CompanyItemCategoriesResponse>('company_item_categories'), {
		enabled,
		select: (data) => {
			const allCategories: CompanyItemCategory[] = [];

			const { exclusive_items, swag_items } = data.data.meta;

			const alphabeticalCategories = data?.data.data ? [...data.data.data].sort((a, b) => a.name.localeCompare(b.name)) : [];

			const exclusivesCategory = exclusive_items
				? [
						{
							id: '',
							key: ItemType.Exclusive,
							name: t('rewards:filters.exclusives'),
						},
					]
				: [];

			const swagCategory = swag_items
				? [
						{
							id: '',
							key: ItemType.Swag,
							name: t('rewards:filters.swag'),
						},
					]
				: [];

			const shopAllCategory =
				data?.data.data.length === 0
					? []
					: [
							{
								id: '',
								key: 'all',
								name: t('rewards:filters.all_categories'),
							},
						];

			return allCategories.concat(exclusivesCategory, swagCategory, alphabeticalCategories, shopAllCategory);
		},
		useErrorBoundary: true,
	});
};
